package efas.common

/** This file is generated from the contents of efas.properties **/

var baseURL: String = "https://efas.node11.net/api"
const val s3URL: String = "https://objects-us-east-1.dream.io/efas-obj"
const val sessionTimeout: Long = 300000
const val nonceTimeout: Long = 120000
const val version = "0.2.1"